<template>
  <div class="Cost">
    <div class="Cost-content">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <!-- 自助报账 -->
        <el-tab-pane label="自助报账" name="first">
          <div class="border-bottom margin-top1" style="overflow: hidden;position: relative;">
            <el-form
              style="overflow: hidden;"
              :model="ruleForm"
              ref="ruleForm"
              class="demo-ruleForm"
              label-width="100px"
            >
              <el-form-item label="审核标识" prop="shopvalue">
                <el-select v-model="ruleForm.shopvalue" placeholder="请选择">
                  <el-option
                    v-for="item in option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    @change="logo"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="账户" prop="staffvalue">
                <el-select v-model="ruleForm.staffvalue" placeholder="请选择">
                  <el-option
                    v-for="item in optionStaff"
                    :key="item.value"
                    :label="item.accountName"
                    :value="item.accountName"
                    @change="account"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="开始日期" prop="starttime">
                <el-date-picker
                  class="width1"
                  @change="startDate1"
                  v-model="ruleForm.starttime1"
                  type="date"
                  placeholder="选择开始日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="endtime">
                <el-date-picker
                  class="width1"
                  @change="endDate1"
                  v-model="ruleForm.endtime1"
                  type="date"
                  placeholder="选择结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="automaticList">搜索</el-button>
                <el-button type="primary" @click="searchReset1">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="Account_Number">汇款账号</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="margin-top1">
            <el-button type="primary" class="search" @click="addReset">增加</el-button>
          </div>
          <div class="margin-top1">
            <el-table :data="DataList1" border style="width: 100%">
              <el-table-column prop="reportingType" label="报账类型" align="center"></el-table-column>
              <el-table-column prop="isAudit" label="是否审核" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.isAudit === 1">审核通过</span>
                  <span v-if="scope.row.isAudit === 2">未审核</span>
                  <span v-if="scope.row.isAudit === 3">审核未通过</span>
                </template>
              </el-table-column>
              <el-table-column prop="documentNumber" label="单据编号" align="center"></el-table-column>
              <el-table-column prop="accountsReceivable" label="汇款账户" align="center"></el-table-column>
              <el-table-column label="上传凭证" align="center">
                <template slot-scope="scope">
                      <el-image
                        v-if="scope.row.uploadCertificateImg.length"
                        style="width: 100px; height: 100px"
                        :src="scope.row.uploadCertificateImg[0]" 
                        :preview-src-list="scope.row.uploadCertificateImg">
                      </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="reportedAmount" label="报账金额" align="center"></el-table-column>
              <el-table-column prop="reportCurrency" label="报账币别" align="center"></el-table-column>
              <el-table-column prop="documentPeople" label="制单人" align="center"></el-table-column>
              <el-table-column prop="createTime" label="制单日期" align="center"></el-table-column>
              <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              style="margin-right:200px;"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[50, 100, 200, 400]"
              :page-size="pagesize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total1"
            ></el-pagination>
          </div>
        </el-tab-pane>

        <!-- 充值记录 -->
        <el-tab-pane label="充值记录" name="second">
          <div class="border-bottom margin-top1" style="overflow: hidden;">
            <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
              <el-form-item label="开始日期" prop="starttime">
                <el-date-picker
                  class="width1"
                  v-model="ruleForm.starttime"
                  type="date"
                  @change="startDate"
                  placeholder="选择开始日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期" prop="endtime">
                <el-date-picker
                  class="width1"
                  v-model="ruleForm.endtime"
                  type="date"
                  @change="endDate"
                  placeholder="选择结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="PrepaidList">搜索</el-button>
                <el-button type="primary" @click="searchReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="margin-top1">
            <el-table :data="DataList" border style="width: 100%">
              <el-table-column prop="documentNumber" label="单据编号" align="center"></el-table-column>
              <el-table-column prop="accountingPeriod" label="会计期间" align="center"></el-table-column>
              <el-table-column prop="receivingAmount" label="收款金额/¥" align="center"></el-table-column>
              <el-table-column prop="reportCurrency" label="收款币别" align="center"></el-table-column>
              <el-table-column prop="accountsReceivable" label="汇款账户" align="center"></el-table-column>
              <el-table-column prop="writeOffAmount" label="核销金额/¥" align="center"></el-table-column>
              <el-table-column prop="writeOffCurrency" label="核销币别" align="center"></el-table-column>
              <el-table-column prop="writeOffTheDifference" label="核销差额" align="center"></el-table-column>
              <el-table-column prop="rechargeDate" label="日期" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              style="margin-right:200px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[50, 100, 200, 400]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="自助报账" :visible.sync="Reimbursement">
      <div class="dialog-item el-row">
        <div class="el-col el-col-24">
          <span class="dialog-left">单据编号</span>
          {{this.Payment.documentNumber}}
        </div>
      </div>
      <div class="dialog-item el-row">
        <div class="el-col el-col-12">
          <span class="dialog-left">汇款账户</span>
          <el-select v-model="PaymentAccount" placeholder="请选择" @change="accountSelect">
            <el-option
              v-for="item in this.Payment.remittanceAccountList"
              :key="item.value"
              :label="item.bank"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="el-col el-col-12">
          <span class="dialog-left">报账类型</span>
          <el-radio v-model="radio" label="货款">货款</el-radio>
        </div>
      </div>
      <div class="dialog-item el-row">
        <div class="el-col el-col-12">
          <span class="dialog-left">报账金额</span>
          <el-input v-model="ReimbursementAmount" style="width: 44%;" placeholder="请输入内容"></el-input>
        </div>
        <div class="el-col el-col-12">
          <span class="dialog-left">报账币别</span>
          <el-select v-model="RMB" placeholder="请选择" @change="reportCurrency">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="dialog-item el-row">
        <div class="el-col el-col-12">
          <span class="dialog-left">报账银行</span>
          <el-input
            v-model="ReimbursementBank"
            style="width: 44%;"
            :disabled="true"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="el-col el-col-12">
          <span class="dialog-left">银行账号</span>
          <el-input v-model="bankAccount" style="width: 44%;" :disabled="true" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <div class="dialog-item el-row">
        <div class="el-col el-col-12">
          <span class="dialog-left">银行户名</span>
          <el-input
            v-model="BankAccountName"
            style="width: 44%;"
            :disabled="true"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="el-col el-col-12">
          <span class="dialog-left">是否备注姓名</span>
          <el-radio v-model="radio1" label="1">是</el-radio>
          <el-radio v-model="radio1" label="0">否</el-radio>
        </div>
      </div>
      <div class="dialog-item el-row">
        <div class="el-col el-col-24">
          <span class="dialog-left">上传凭证</span>
          <el-upload
            ref="upload"
            :action="action"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :headers="customHeaders"
          >
            <i class="el-icon-plus" style="color: #0724ef;"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </div>
      </div>
      <div style="color: red;line-height: 1;">温馨提示:除工行，交行必须上传凭证以外，其他银行打款时必须备注客户名</div>
      <div class="dialog-item el-row margin-top3">
        <div class="el-col el-col-24">
          <span class="dialog-left">备注</span>
          <el-input
            type="textarea"
            style="width: 83%;"
            :rows="4"
            placeholder="请输入内容"
            v-model="textarea"
          ></el-input>
        </div>
      </div>
      <div class="dialog-item el-row margin-top3">
        <div class="el-col el-col-24">
          <div style="float: right;">
            <el-button type="primary" @click="Preservation">保存</el-button>
            <el-button @click="Reimbursement = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="汇款账号" :visible.sync="Remittance" width="40%">
      <div class="remittance">
        <el-table :data="RemittancesAccount" border style="width: 100%">
          <el-table-column prop="bank" label="银行"></el-table-column>
          <el-table-column prop="accountOpeningBranch" label="开户支行"></el-table-column>
          <el-table-column prop="accountName" label="户名"></el-table-column>
          <el-table-column prop="accountNumber" label="账号"></el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          style="text-align:center;"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="currentPage2"
          :page-sizes="[50, 100, 200, 400]"
          :page-size="pagesize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
  name: "Cost",
  data() {
    return {
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      Reimbursement: false,
      Remittance: false,
      dialogVisible: false,
      RemittancesAccount: [],
      imageData: [],
      dialogImageUrl: [],
      arr: [],
      radio: "货款",
      radio1: "1",
      textarea: "",
      input: "",
      options: [{ label: "人民币", value: "0" }],
      value: "",
      RMB: "人民币",
      activeName: "first",
      Payment: "",
      ReimbursementBank: "",
      bankAccount: "",
      BankAccountName: "",
      PaymentAccount: "",
      ReimbursementAmount: "",
      reportingType1: "货款",

      currentPage: 1,
      pagesize: 50,
      size: 50,
      total: 0,

      currentPage1: 1,
      pagesize1: 50,
      size1: 50,
      total1: 0,

      currentPage2: 1,
      pagesize2: 50,
      size2: 50,
      total2: 0,

      tableData: [],
      DataList: [],
      DataList1: [],
      optionStaff: [],
      option: [
        { value: "1", label: "审核通过" },
        { value: "2", label: "未审核" },
        { value: "3", label: "审核未通过" },
      ],

      ruleForm: {
        staffvalue: "", //账户
        shopvalue: "", //审核标识
        starttime: "", //开始时间
        endtime: "", //结束时间

        starttime1: "", //开始时间
        endtime1: "" //结束时间
      }
    };
  },
  mounted() { },
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
    this.PrepaidList()
    this.automaticList()
    this.Add()
    if (this.$route.params.activeName) {
      this.activeName = this.$route.params.activeName
    }
  },
  methods: {
    PrepaidList() {
      var obj = {
        companyId: this.str.company_id,
        beginDate: this.ruleForm.starttime,
        endDate: this.ruleForm.endtime,
        page: this.currentPage,
        size: this.size
      }
      ajaxPost(Baseurl + "selfReportController/selectRechargeRecord", obj).then(res => {
        this.DataList = res.data.data.list
        this.total = res.data.data.total
      })
    },
    automaticList() {
      var obj = {
        companyId: this.str.company_id,
        beginDate: this.ruleForm.starttime1,
        endDate: this.ruleForm.endtime1,
        accountName: this.ruleForm.staffvalue,
        isAudit: this.ruleForm.shopvalue,
        page: this.currentPage1,
        size: this.size1
      }
      ajaxPost(Baseurl + "selfReportController/selectSelfReportInfo", obj).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          data.list.forEach(item => item.uploadCertificateImg = JSON.parse(item.uploadCertificate))
          this.DataList1 = data.list
          this.total1 = data.total
        }
      })
    },
    //选择开始日期
    startDate(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 00:00:00";
      this.ruleForm.starttime = datetime;
    },
    //选择结束日期
    endDate(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 23:59:59";
      this.ruleForm.endtime = datetime;
    },

    //选择开始日期
    startDate1(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 00:00:00";
      this.ruleForm.starttime1 = datetime;
      console.log(this.ruleForm.starttime1)
    },
    //选择结束日期
    endDate1(val) {
      var d = new Date(val);
      var datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " 23:59:59";
      this.ruleForm.endtime1 = datetime;
      console.log(this.ruleForm.endtime1)
    },

    account(val) {
      this.ruleForm.staffvalue = val
    },
    logo(val) {
      this.ruleForm.shopvalue = val
    },
    searchReset() {
      this.ruleForm.endtime = ""
      this.ruleForm.starttime = ""
      this.PrepaidList()
    },
    searchReset1() {
      this.ruleForm.staffvalue = ""
      this.ruleForm.shopvalue = ""
      this.ruleForm.endtime1 = ""
      this.ruleForm.starttime1 = ""
      this.automaticList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.size = val;
      this.PrepaidList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.PrepaidList()
    },

    handleSizeChange1(val) {
      console.log(`每页 ${val} 条`);
      this.size1 = val;
      this.automaticList()
    },
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`);
      this.currentPage1 = val;
      this.automaticList()
    },

    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`);
      this.size2 = val;
      var obj = {
        companyId: this.str.company_id,
        page: this.currentPage2,
        size: this.size2
      }
      ajaxPost(Baseurl + "remittanceAccountController/selectAccountsReceivableInfoByCompanyId", obj).then(res => {
        this.RemittancesAccount = res.data.data.list
        this.total2 = res.data.data.total
      })
    },
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`);
      this.currentPage2 = val;
      var obj = {
        companyId: this.str.company_id,
        page: this.currentPage2,
        size: this.size2
      }
      ajaxPost(Baseurl + "remittanceAccountController/selectAccountsReceivableInfoByCompanyId", obj).then(res => {
        this.RemittancesAccount = res.data.data.list
        this.total2 = res.data.data.total
      })
    },

    accountSelect(val) {
      var obj = {
        id: val.id
      }
      ajaxPost(Baseurl + "remittanceAccountController/selectRemittanceAccountById", obj).then(res => {
        this.ReimbursementBank = res.data.data.accountOpeningBranch
        this.bankAccount = res.data.data.accountNumber
        this.BankAccountName = res.data.data.accountName
      })
    },
    reportCurrency(val) {
      console.log(val)
      this.RMB = val
    },
    //图片上传
    handleAvatarSuccess(file, fileList) {
      this.imageData.push(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //删除要上传的图片
    handleRemove(file, fileList) {
      this.imageData = []
      for (var i = 0; i < fileList.length; i++) {
        this.imageData.push(fileList[i].response)
      }
    },
    Add() {
      var obj = {
        id: this.str.company_id
      }
      ajaxPost(Baseurl + "remittanceAccountController/selectAccountsReceivableByCompanyId", obj).then(res => {
        this.optionStaff = res.data.data.remittanceAccountList
        this.Payment = res.data.data
      })
    },
    // 增加
    addReset() {
      this.Reimbursement = true;
      this.Add()
    },
    // 保 存
    Preservation() {
      if (this.PaymentAccount === "") {
        this.$message.error("请选择收款账户")
      }
      else if (this.ReimbursementAmount === "") {
        this.$message.error("请输入报账金额")
      }
      else if (this.RMB === "") {
        this.$message.error("请选择报账币别")
      }
      else {
        for (var i = 0; i < this.imageData.length; i++) {
          this.arr.push(this.imageData[i].data)
        }
        var obj = {
          rid: this.str.rid,
          accountsReceivable: this.PaymentAccount.bank,
          reportedAmount: this.ReimbursementAmount,
          reportingType: this.radio,
          reportCurrency: this.RMB,
          reportingBank: this.ReimbursementBank,
          bankAccount: this.bankAccount,
          accountName: this.BankAccountName,
          documentNumber: this.Payment.documentNumber,
          isRemarkName: this.radio1,
          uploadCertificates: this.arr,
          companyId: this.str.company_id,
          remarks: this.textarea
        }
        console.log(obj)
        ajaxPost(Baseurl + "selfReportController/insertSelfReportInfo", obj).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            this.automaticList()
          } else {
            this.$message.error("保存失败")
          }
          this.PaymentAccount = ""
          this.ReimbursementAmount = ""
          this.radio = "货款"
          this.RMB = "人民币"
          this.ReimbursementBank = ""
          this.bankAccount = ""
          this.BankAccountName = ""
          this.Payment.documentNumber = ""
          this.radio1 = "1"
          this.textarea = ""

          this.imageData = []
          this.$refs.upload.clearFiles();
          this.Reimbursement = false;
        })
      }
    },
    // 汇款账号
    Account_Number() {
      this.Remittance = true;
      var obj = {
        companyId: this.str.company_id,
        page: this.currentPage2,
        size: this.size2
      }
      ajaxPost(Baseurl + "remittanceAccountController/selectAccountsReceivableInfoByCompanyId", obj).then(res => {
        this.RemittancesAccount = res.data.data.list
        this.total2 = res.data.data.total
      })
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {

    },
  }
};
</script>

<style lang="scss">
.Cost {
  width: 98%;
  margin-bottom: 50px;
  overflow: hidden;
  .Cost-content {
    .el-form-item {
      overflow: hidden;
      width: 16%;
      margin-bottom: 18px;
      float: left;
    }
    .remittance_account {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .Reportform_tiem {
      overflow: hidden;
      border-top: 1px solid #eee;
      padding: 15px 0;
      .search-result-text {
        font-size: 14px;
        color: #606266;
        padding: 0;
      }
      .el-radio-group {
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
        font-size: 0;
        margin-left: 20px;
      }
    }
    .paging {
      width: 40%;
      margin: 20px auto;
    }
  }
  .el-dialog__wrapper {
    .el-dialog__body {
      .dialog-item {
        margin-bottom: 20px;
        .dialog-left {
          margin-right: 50px;
        }
      }
    }
    .remittance {
      width: 96%;
      margin: 30px auto 0;
      padding: 0 0 30px 0;
      overflow: hidden;
    }
  }
  .page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
  .footer {
    text-align: center;
  }
}
</style>
